import { render, staticRenderFns } from "./IntervencionesHome.vue?vue&type=template&id=319f0cca"
import script from "./IntervencionesHome.vue?vue&type=script&lang=js"
export * from "./IntervencionesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports